import { createStyledClone } from '@/services/print/svghelpers';

export default ({ title = '--', description, colorClass = 'print.primary.7', icon }, { title: titleOptions = {}, description: descriptionOptions = {} } = {}) => ({
    position: 'content',
    title: {
        x: icon && 40,
        text: title,
        font: { colour: `${colorClass}`, weight: 'lighter' },
        ...titleOptions
    },
    description: description && {
        markdown: { link: { colour: `${colorClass}` } },
        text: description,
        ...descriptionOptions
    },
    icon: icon && {
        position: 'content',
        w: 50,
        h: 50,
        y: -15,
        x: -10,
        svg: createStyledClone({ selector: `#${icon}` })
    }
});
